import ajax from "../utils/request";
const aiManageApi = {
  /********************************ai管理*********************************** */
  /********************************提示词列表*********************************** */
  // 获取提示词列表
  getPromptList(params) {
    return ajax({
      url: "/ai_prompt/list",
      type: "get",
      params: params,
    });
  },
  // 获取全部一级列表
  getOneLevelPromptList(params) {
    return ajax({
      url: "/ai_prompt/promptList",
      type: "get",
      params: params,
    });
  },
  // 添加提示词
  addPrompt(params) {
    return ajax({
      url: "/ai_prompt/add",
      type: "post",
      params: params,
    });
  },
  // 删除提示词
  delPrompt(params) {
    return ajax({
      url: "/ai_prompt/del",
      type: "delete",
      params: params,
    });
  },
  // 修改提示词
  updatePrompt(params) {
    return ajax({
      url: "/ai_prompt/update",
      type: "post",
      params: params,
    });
  },
  /********************************绘图任务列表*********************************** */
  // 获取绘图任务列表
  getDrawTaskList(params) {
    return ajax({
      url: "/draw_task/list",
      type: "get",
      params: params,
    });
  },
  // 添加绘图任务
  addDrawTask(params) {
    return ajax({
      url: "/draw_task/add",
      type: "post",
      params: params,
    });
  },
  // 开始绘图
  startDraw(params) {
    return ajax({
      url: "/draw_task/draw",
      type: "post",
      params: params,
    });
  },
  // 重绘
  reDraw(params) {
    return ajax({
      url: "/draw_task/redraw",
      type: "post",
      params: params,
    });
  },
  // 删除绘图任务
  delDrawTask(params) {
    return ajax({
      url: "/draw_task/del",
      type: "delete",
      params: params,
    });
  },
  // 修改绘图任务
  updateDrawTask(params) {
    return ajax({
      url: "/draw_task/update",
      type: "post",
      params: params,
    });
  },
  // 查询绘画配置
  queryDrawConfig() {
    return ajax({
      url: "/draw_task/default_config",
      type: "get",
    });
  },
  /********************************AI标签生成器*********************************** */
  // 查询所有AI提示词
  queryAllPrompt() {
    return ajax({
      url: "/ai_prompt/allList",
      type: "get",
    });
  },
  /********************************绘画工具*********************************** */
  // 查询默认配置
  queryDefaultConfig() {
    return ajax({
      url: "/sys_config/default",
      type: "get",
    });
  },
  /********************************绘画记录*********************************** */
  // 查询绘画记录
  queryDrawRecord(params) {
    return ajax({
      url: "/draw_record/list",
      type: "get",
      params: params,
    });
  },
};
export default aiManageApi;
